import currenciesLocales from '@/shared/enums/currenciesLocales'

export default (amount, currency = 'USD') => {
  const locale = currenciesLocales[currency.toUpperCase()] || 'en-US'
  const formatted = parseFloat(amount)

  const formattedCurrency = formatted.toLocaleString(locale, { style: 'currency', currency: currency.toUpperCase(), minimumFractionDigits: 2 })
  return formattedCurrency
}